import { Button, ButtonProps, SxProps } from '@mui/material';

interface MuiButtonProps extends ButtonProps {
  fullRadius?: boolean;
  sx?: SxProps;
}

export function MuiButton(props: MuiButtonProps) {
  const { sx, variant = 'contained', fullRadius, ...rest } = props;

  const fullRadiusStyle = fullRadius ? { borderRadius: 100 } : {};

  return (
    <Button variant={variant} sx={{ ...sx, ...fullRadiusStyle }} {...rest}>
      {props.children}
    </Button>
  );
}
